var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 25.8476C25.6392 25.8476 28.2481 25.1242 28.5 22.2205C28.5 19.3188 26.6812 19.5054 26.6812 15.9451C26.6812 13.1641 24.0452 10 20 10C15.9548 10 13.3188 13.1641 13.3188 15.9451C13.3188 19.5054 11.5 19.3188 11.5 22.2205C11.753 25.1352 14.3618 25.8476 20 25.8476Z",
    stroke: "#425466",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3889 28.8572C21.0247 30.3719 18.8967 30.3899 17.5195 28.8572",
    stroke: "#425466",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationInactive);
export default __webpack_public_path__ + "static/media/notification-inactive.5b48005ab72f4dbdfe9a1b2705a07ca7.svg";
export { ForwardRef as ReactComponent };